export default "__VITE_ASSET__ea16ac16__"